module.exports = __webpack_public_path__ + "static/media/3040169000_01.b9913473.jpg";